import { combineReducers } from "redux";
import homeReducer from "./homeReducer";

const reducer = combineReducers({homeReducer})

export default reducer;